import React, { useEffect, useState } from 'react'
import { ArrayChecker, Container } from '../../../components'
import { Accordion } from './accordion'
// import careers from '../../../database/careers.json'
import AccordionNav from './section-accordion-nav'
import { useLocation } from 'react-router-dom'
import { useViewport } from '../../../utils'
import apiService from '../../../features/api/service'

const SectionAccordion = () => {
  const { isDesktop } = useViewport()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const currentCategoryId = params.get('category')
  const [masterItems, setMasterItems] = useState([])
  const [items, setItems] = useState([])

  useEffect(() => {
    // Fetch data
    apiService.get('careers')
      .then(res => {
        if(res.results){
          const slides = []
          for (let index = 0; index < res.results.length; index++) {
            const element = res.results[index];
            slides.push({
              id: element.pkDaftarLoker,
              title: element.judul,
              content: {
                en: element.deskripsi,
                id: element.deskripsi
              },
              category: {
                id: element.kategori,
                key: element.kategori,
                name: {
                  en: element.kategori,
                  id: element.kategori
                }
              }
            })
          }
          setMasterItems(slides)
        }
      })
  }, [])

  useEffect(() => {
    if(currentCategoryId){
      setItems(masterItems.filter(c => c.category.key === currentCategoryId/* parseInt(currentCategoryId) */))
    } else {
      setItems(masterItems)
    }
  }, [currentCategoryId, masterItems])

  return (
    <Container className="py-10 lg:py-20 lg:pb-24">
      <div className="flex flex-wrap lg:-mx-4" style={isDesktop ? {minHeight: `${masterItems.length*120}px`} : {}}>
        <div className="lg:w-4/12 lg:px-4">
          <AccordionNav />
        </div>
        <div className="lg:w-8/12 lg:px-4">
          <ArrayChecker data={items}>
            <Accordion items={items}/>
          </ArrayChecker>
        </div>
      </div>
    </Container>
  )
}

export { SectionAccordion }
